<template>
  <div>
    <div v-if="!Array.isArray(params.value)">{{ params.value }}</div>
    <div v-else>
      <Popper placement="right" arrow class="products-popper">
        <div class="products-renderer">
          <button class="btn btn-w">
            <i class="fal fa-clipboard-list"></i>
          </button>
        </div>
        <template #content>
          <table class="product-table">
            <tr v-for="(entity, index) of params.value" :key="index">
              <td>{{ entity }}</td>
            </tr>
          </table>
        </template>
      </Popper>
    </div>
  </div>
</template>
